import { useEffect, useState } from "react";

export const useScrollDirection = () => {
  const [scrollDir, setScrollDir] = useState<"up" | "down">("up");

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let scrollTimer: NodeJS.Timeout | null = null;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? "down" : "up";
      
      if (Math.abs(scrollY - lastScrollY) > 10) {
        setScrollDir(direction);
        lastScrollY = scrollY;
      }

      // Clear existing timer
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }

      // Set timer to show bars after scrolling stops
      scrollTimer = setTimeout(() => {
        setScrollDir("up");
      }, 150); // Show bars 150ms after scrolling stops
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
    };
  }, []);

  return scrollDir;
};